import { useCallback, useRef, useState } from "react";
import * as reportsV3Service from "services/reportsV3Service";

export const useReportPreview = () => {
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewTitle, setPreviewTitle] = useState("");
  const [previewData, setPreviewData] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(false);
  const [previewError, setPreviewError] = useState(null);
  const previewRequestRef = useRef(0);

  const [executeReport] = reportsV3Service.useExecuteReportMutation();

  const handlePreviewReport = useCallback(
    async (reportInternalName, reportDisplayName) => {
      const requestId = ++previewRequestRef.current;
      setPreviewTitle(reportDisplayName);
      setPreviewData(null);
      setPreviewError(null);
      setPreviewLoading(true);
      setPreviewOpen(true);
      try {
        const data = await executeReport({
          reportId: reportInternalName,
          outputType: "JSON",
          limitRows: 20,
        }).unwrap();
        if (requestId !== previewRequestRef.current) return;
        setPreviewData(data);
      } catch (e) {
        if (requestId !== previewRequestRef.current) return;
        setPreviewError(e?.data || e?.message || String(e));
      } finally {
        if (requestId === previewRequestRef.current) {
          setPreviewLoading(false);
        }
      }
    },
    [executeReport]
  );

  const closePreview = useCallback(() => setPreviewOpen(false), []);

  return {
    previewOpen,
    previewTitle,
    previewData,
    previewLoading,
    previewError,
    handlePreviewReport,
    closePreview,
  };
};
